<script setup lang="ts">
  import type { InfoBlockCtaStoryblok } from '@/storyblok/component-types-sb'

  const { locale } = useI18n()

  const props = defineProps<{
    blok: InfoBlockCtaStoryblok
  }>()

  const dataLayer = computed(() => {
    if (props.blok.dataLayerEventOnCta && props.blok.cta) {
      return {
        event: props.blok.dataLayerEvent ?? '',
        event_action: props.blok.dataLayerAction ?? '',
        event_category: props.blok.dataLayerCategory ?? '',
        page_type: props.blok.dataLayerPageType ?? '',
        site_language: locale.value
      }
    }

    return null
  })
</script>

<template>
  <UiInfoCta
    :title="blok.title || ''"
    :variant="blok.variant || undefined"
    :cta="blok.cta"
    :cta-title="blok.ctaTitle"
    :data-layer="dataLayer"
  >
    <template #content>
      <StoryblokComponent
        v-for="item in blok.text"
        :key="item._uid"
        :blok="item"
        class="!mt-0"
      />
    </template>
  </UiInfoCta>
</template>
